import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IconName } from '@shinetools/sunshine-icons';

import { formatAmount } from 'common/formatAmount';
import ProgressBar from 'components/_core/ProgressBar';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import Text from 'components/_core/Text';

import locales from './locales';

interface CardLimitProps {
  isEditable?: boolean;
  to?: string;
  title?: string;
  ratioDescription: string;
  usedAmount: number;
  limitAmount: number;
  iconName?: IconName;
}

const CardLimit: FC<CardLimitProps> = ({
  iconName,
  isEditable,
  limitAmount,
  ratioDescription,
  title,
  to,
  usedAmount,
}) => {
  const wrapperProps = isEditable && to ? { as: Link, to } : {};

  return (
    <SunshineCard {...wrapperProps}>
      {iconName ? (
        <SunshineCard.Slot name="aside">
          <SquircleIcon name={iconName} />
        </SunshineCard.Slot>
      ) : null}

      <SunshineCard.Content>
        <SunshineCard.Title>{title}</SunshineCard.Title>

        <SunshineCard.Text>
          {locales.formatString(locales.description, {
            amount: formatAmount({
              forcePlusSign: false,
              value: usedAmount,
            }),
            maxAmount: formatAmount({
              forcePlusSign: false,
              value: limitAmount,
            }),
          })}
        </SunshineCard.Text>

        <ProgressBar
          marginY="space-4"
          ratio={limitAmount === 0 ? 0 : usedAmount / limitAmount}
        />

        <Text size="sm">{ratioDescription}</Text>
      </SunshineCard.Content>

      {isEditable ? (
        <SunshineCard.Slot name="action">
          <SunshineCard.SunshineIcon name="edit" />
        </SunshineCard.Slot>
      ) : null}
    </SunshineCard>
  );
};

export default CardLimit;
